import { render, staticRenderFns } from "./ClassHomework.vue?vue&type=template&id=2f9278ff&scoped=true"
import script from "./ClassHomework.vue?vue&type=script&lang=js"
export * from "./ClassHomework.vue?vue&type=script&lang=js"
import style0 from "./ClassHomework.vue?vue&type=style&index=0&id=2f9278ff&prod&scoped=true&less=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9278ff",
  null
  
)

export default component.exports